/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Priceid2Inputs */

const en__field_priceid2 = /** @type {(inputs: _Field_Priceid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Price ID`)
};

const de__field_priceid2 = /** @type {(inputs: _Field_Priceid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Price ID`)
};

/**
* | output |
* | --- |
* | "Price ID" |
*
* @param {_Field_Priceid2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_priceid2 = /** @type {((inputs?: _Field_Priceid2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Priceid2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_priceid2(inputs)
	return de__field_priceid2(inputs)
});
export { _field_priceid2 as "_field_priceID" }